import React from 'react';
import CountUp from 'react-countup';
import misc from '../misc.json';
import { useTranslation } from 'react-i18next';
import SEO from './SEO';

const About = () => {
    const { t } = useTranslation();

    return (
        <div>
            <SEO
                title={t('about_page_title')}
                description={t('about_text_p1') + ' ' + t('about_text_p2')}
            />
            <div className="fh5co-narrow-content">
                <div className="row">
                    <div className="col-md-12">
                        <h1 className="fh5co-heading animate-box" data-animate-effect="fadeInLeft" style={{ fontSize: '32px' }}>
                            {t('about_heading_part1')} <span> {t('about_heading_part2')}</span>
                        </h1>
                        <p>
                            {t('about_text_p1')}
                            <br /><br />
                            {t('about_text_p2')}
                        </p>
                    </div>
                    <div className="col-md-6 col-md-push-1 animate-box" data-animate-effect="fadeInLeft">
                    </div>
                </div>

            </div>
            <div className="fh5co-counters header-white">
                <div className="fh5co-narrow-content">
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <CountUp className="fh5co-counter" style={{color: "dimgray"}} end={misc['services']} duration={2} delay={0} />
                            <span className="fh5co-counter-label" style={{color: "dimgray"}}>{t('offered_services')}</span>
                        </div>
                        <div className="col-md-4 text-center">
                            <CountUp className="fh5co-counter" style={{color: "dimgray"}} end={misc['clients']} duration={2} delay={0} />
                            <span className="fh5co-counter-label" style={{color: "dimgray"}}>{t('partners')}</span>
                        </div>
                        <div className="col-md-4 text-center">
                            <CountUp className="fh5co-counter" style={{color: "dimgray"}} end={misc['deals']} duration={2} delay={0} />
                            <span className="fh5co-counter-label" style={{color: "dimgray"}}>{t('deals')}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;